<!--价格管理 销售报价分组 -->
<template>
  <div>
    <el-row>
      <el-col>
        <el-button size="medium" @click="addNewKind">新增分组</el-button>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table stripe border :data="tableData" style="margin-top:20px">
          <el-table-column label="序号" type="index" width="50"></el-table-column>
          <el-table-column label="分组名称" prop="CLIENT_AREA"></el-table-column>
          <el-table-column label="操作" min-width="50px">
            <template slot-scope="scope">
              <el-button type="text" size="small" icon="el-icon-view" @click="skuProduct(scope.row)">查看</el-button>
              <el-button type="text" size="small" icon="el-icon-edit-outline" @click="editProduct(scope.row)">修改
              </el-button>
              <el-button type="text" size="small" icon="el-icon-close" style="color: rgb(245, 108, 108)"
                @click="deleteProduct(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <!-- 增加分组 -->
        <el-dialog title="新增分组" center :visible.sync="addFormVisible" width="600px">
          <el-form size="small" :model="addForm" ref="addForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="addForm.Name"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitAdd" v-if="this.addForm.Name === ''" disabled>确 定</el-button>
            <el-button size="small" @click="submitAdd" v-else>确 定</el-button>
          </div>
        </el-dialog>
        <!-- 修改模态框 -->
        <el-dialog title="修改分组" center :visible.sync="editFormVisible" width="600px">
          <el-form size="small" :model="editForm" ref="editForm">
            <el-form-item label="分组名称：" :label-width="formLabelWidth">
              <el-input v-model="editForm.CLIENT_AREA"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="close">取 消</el-button>
            <el-button size="small" @click="submitEdit">确 定</el-button>
          </div>
        </el-dialog>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import {
  addPriceGroupFun, deletePriceGroupFun, editPriceGroupFun, getPriceGroupFun,
} from 'api/systemSetting';

export default {
  data() {
    return {
      tableData: [],
      addForm: {
        Name: '',
      },
      // loading: false,
      addFormVisible: false,
      formLabelWidth: '120px',
      editForm: {},
      editFormVisible: false,
    };
  },
  created() {
    this.queryTable();
  },
  methods: {
    addNewKind() {
      this.addFormVisible = true;
    },
    editProduct(row) {
      this.editFormVisible = true;
      this.editForm = row;
    },
    skuProduct(row) {
      this.$router.push({ path: '/matchPriceGroup/detail' });
      sessionStorage.setItem('areaId', row.ID);
    },
    // --------------------------添加分组
    submitAdd() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            CLIENT_AREA: this.addForm.Name,
          };
          addPriceGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '新增品类成功', type: 'success' });
              this.addFormVisible = false;
              this.addForm = {};
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // ------------------------------------删除功能
    deleteProduct(row) {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            AREA_ID: row.ID,
          };
          deletePriceGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '删除成功', type: 'success' });
              this.queryTable();
              document.body.style.cursor = 'default';
            }).catch((error) => {
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    // -----------------------------------修改功能
    submitEdit() {
      if (document.body.style.cursor === 'wait') {
      } else {
        document.body.style.cursor = 'wait';
        try {
          const params = {
            AREA_ID: this.editForm.ID,
            CLIENT_AREA: this.editForm.CLIENT_AREA,
          };
          if (!this.editForm.CLIENT_AREA) {
            this.$message.show({ text: '请输入分组名称', type: 'warning' });
            return false;
          }
          // this.loading = true
          editPriceGroupFun(params)
            .then((result) => {
              this.$message.show({ text: '修改品类成功', type: 'success' });
              this.editFormVisible = false;
              this.editForm = {};
              this.queryTable();
              // this.loading = false
              document.body.style.cursor = 'default';
            }).catch((error) => {
              // this.loading = false
              this.$message.show({ text: error, type: 'error' });
              document.body.style.cursor = 'default';
            });
        } finally {
          // console.log("我执行完了")
          // document.body.style.cursor="default";
        }
      }
    },
    close() {
      this.addFormVisible = false;
      this.editFormVisible = false;
      this.addForm = {};
    },
    // -----------------------------------进入页面拉取数据
    queryTable() {
      getPriceGroupFun()
        .then((result) => {
          this.tableData = result;
        }).catch((error) => {
          this.$message.show({ text: error, type: 'error' });
        });
    },
    handleCurrentChange() {
      this.queryTable();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/priceManagement/priceGroup.vue